import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Phone } from "lucide-react";
import { BUSINESS, IMAGES } from "../data/site";
import { Reveal } from "./Reveal";

export default function OrderCTA() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="order" data-testid="order-cta-section" ref={ref} className="relative overflow-hidden bg-charcoal py-28 text-cream md:py-40">
      <motion.div style={{ y }} className="absolute inset-y-[-15%] inset-x-0">
        <img src={IMAGES.woodfire} alt="" aria-hidden className="h-full w-full object-cover opacity-40" />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal via-charcoal/25 to-charcoal" />
      <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-start px-5 md:px-10">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.4em] text-gold" data-testid="order-cta-kicker">
            Order Online
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif leading-[1.05] tracking-tight text-[13vw] md:text-7xl">
            Ready to <span className="italic text-ember">Order?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-md text-base text-cream/70 md:text-lg">
            Order your favourite pizza, burgers and sides today. Call ahead and we'll have it hot and ready.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <a
            data-testid="order-cta-call-button"
            href={BUSINESS.phoneHref}
            className="btn-pulse group mt-10 flex items-center gap-4 rounded-full bg-ember px-10 py-5 text-sm font-bold uppercase tracking-widest text-cream transition-transform duration-300 hover:scale-105 hover:bg-[#991B1B] md:text-base"
          >
            <Phone size={18} className="transition-transform duration-300 group-hover:rotate-12" />
            Call {BUSINESS.phoneDisplay}
          </a>
        </Reveal>
        <Reveal delay={0.4}>
          <p className="mt-6 text-xs font-medium uppercase tracking-[0.3em] text-cream/50">
            Pickup available · Hospital delivery $5 · Free delivery over $40
          </p>
        </Reveal>
      </div>
    </section>
  );
}
